<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th(colspan="4")
              div {{ $t('ui.full_time') }}
            th(colspan="3")
              div {{ $t('ui.half_time') }}
          tr
            th(style="width: 100px;")
              div 0-1
            th(style="width: 100px;")
              div 2-3
            th(style="width: 100px;")
              div 4-6
            th(style="width: 100px;")
              div 7+
            th(style="width: 100px;")
              div 0-1
            th(style="width: 100px;")
              div 2-3
            th(style="width: 100px;")
              div 4+
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item['ftg01_blink'] }") {{ item['ftg01'] }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item['ftg23_blink'] }") {{ item['ftg23'] }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item['ftg46_blink'] }") {{ item['ftg46'] }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item['ftg7o_blink'] }") {{ item['ftg7o'] }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item['htg01_blink'] }") {{ item['htg01'] }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item['htg23_blink'] }") {{ item['htg23'] }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item['htg4o_blink'] }") {{ item['htg4o'] }}
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>
